const FormRow = ({ children }) => {
  return <div className="form__row">{children}</div>;
};

export default FormRow;
